exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.d-flex[data-v-586657c1] {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n", ""]);

